import React, { useState, useEffect } from "react";
import { SidePopup } from "../../components/model-popup/side-popup";
import { CustomButton } from "../../components/buttons/button";
import { useFormik } from "formik";
import * as yup from "yup";
import TextIconInput from "../../components/custom-fields/input";
import SelectInput from '../../components/custom-fields/select';
import ErrorMessage from "../../components/custom-fields/error-message";
import { alphabetValidate} from "../../utils/field-validation";
import { NotesErrorPutAPI } from "../../api/update";
// import toast from "react-hot-toast";
import {toast} from "react-toastify";

import moment from "moment";

export const NotesErrorPopup = (props: any) => {
    const {
        showModal,
        setShowModal,
        title,
        handleClose,
        poupDetails,
        afterChangeNotesList,
        facList,
    } = props;
    const [facilityList,setFacilityList] = useState(facList)
    const [selectLocation, setSelectLocation] = useState<string>('');
    
    const handleSearch = (term:string) => {
        const filteredFacilities = facList.filter((facility:any) => 
          facility.facilityName?.toLowerCase().includes(term?.toLowerCase())
        );
        if (filteredFacilities.length === 0) {
            setFacilityList([...facList,{ facilityName: term, id: '' }])
            return term;
        } else {
            return filteredFacilities[0].facilityName
        }
      };

    useEffect(() => {
        if (poupDetails?.location) {
            const location = handleSearch(poupDetails.location);
            setSelectLocation(location);  
        }
    }, [poupDetails?.location, facList]);  

    const ConvertDate = (date_string:string) => {
        const isValidFormat: boolean = moment(date_string, "YYYY-MM-DD", true).isValid();
        const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["MM/DD/YYYY", "DD/MM/YYYY"]).format("YYYY-MM-DD");
        return formattedDate
      };

    const ConvertOutputDate = (date_string:string) => {
        const isValidFormat: boolean = moment(date_string, "MM/DD/YYYY", true).isValid();
        const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("MM/DD/YYYY");
        return formattedDate
      };


   const [buttonLoader, setButtonLoader] = useState<boolean>(false);
   const formik: any = useFormik({
           enableReinitialize: true,
           initialValues: {
               patient_first_name: poupDetails?.patient_first_name || "",
               patient_last_name: poupDetails?.patient_last_name || "",
               location: selectLocation,
               DOB: poupDetails?.DOB ? ConvertDate(poupDetails?.DOB) : "",
               gender: poupDetails?.gender?.toLowerCase() || ''
           },
   
           validationSchema: yup.object({
               patient_first_name: yup.string().required("First Name is required"),
               patient_last_name: yup.string().required("Last Name is required"),
               location: yup.string().required("location is required"),
               DOB: yup.string().required("DOB is required"),
           }),
           onSubmit: async (values: any) => {
               setButtonLoader(true);
               const formattedDOB = ConvertOutputDate(values.DOB);
               const data = {
                   ...values,
                   DOB: formattedDOB,
   
               }
               const handleUploadAPI = async () => {
                   
                    await NotesErrorPutAPI(poupDetails?.id,{
                    ...data,
                    })
                    .then(async (res: any) => {
                
                        if (res?.result) {
                        toast.success(res?.result?.message || "User created success");
                        setShowModal(false);
                        formik?.resetForm();
                        afterChangeNotesList()
                        } else {
                        if (res?.message)
                            toast.error(res?.message || "Update notes failed");
                        }
                    })
                    .catch((err: any) => {
                        console.error(err);
                    });
                   
                   setButtonLoader(false);
               };
               await handleUploadAPI()
           },
       });

    async function handleErrorFields() {
        await formik.validateForm();
        if (formik?.errors) {
            const errorField: any = Object.keys(formik.errors)?.[0];
            document.getElementById(errorField)?.focus();
            document.getElementById(errorField)?.scrollIntoView({
                block: "center",
                inline: "end",
                behavior: "smooth",
            });
        }
    }

    return (
        //eslint-disable-next-line
        //@ts-ignore
        <SidePopup
            showModal={showModal}
            handleClose={handleClose}
            title={title}
            // clearFormik={() => formik.resetForm()}
            closeIcon={false}
            footerStyle="flex justify-end gap-[16px] "
            footerContent={
                    <>
                        <CustomButton
                            buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                            buttonName="Cancel"
                            primary={false}
                            disable={buttonLoader}
                            onClick={() => {
                                    setShowModal(false);
                                    // setPoupDetails({});
                                    // setDecrypt("");
                                    // setViewOnly(false);
                                    // setShowPassword(false);
                                
                                formik.resetForm();
                            }}
                        />
                        <CustomButton
                            type="submit"
                            loader={buttonLoader}
                            loaderStyle={` ${title === "Edit User" ? "px-[52px]" : "px-[40.5px]"
                                } py-[13px] leading-[17px]`}
                            primary={true}
                            disable={buttonLoader}
                            buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
                            buttonName={"Update"}
                            onClick={() => {
                                handleErrorFields();
                                formik.handleSubmit();
                            }}
                        />
                    </>
            }
        >
            

            <div
                className="pt-[1px] grid grid-cols-1 gap-x-[12px]"
                
            >
                <div className="w-full col-span-1 mb-[2px]">
                    <TextIconInput
                        label="Patient First Name"
                        name="patient_first_name"
                        id="patient_first_name"
                        type="text"
                        disable={buttonLoader}
                        maxLength={30}
                        value={formik.values.patient_first_name}
                        onChange={formik.handleChange}
                        onkeypress={alphabetValidate}
                        errors={formik.errors.patient_first_name
                             && 
                             formik.touched.patient_first_name}
                        placeholder="Enter patient first name"
                        onBlur={formik.handleBlur}
                        required
                    />
                    {formik.errors.patient_first_name && formik.touched.patient_first_name ? (
                        <ErrorMessage>{formik.errors.patient_first_name}</ErrorMessage>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>
                <div className="w-full col-span-1 mb-[2px]">
                    <TextIconInput
                        label="Patient Last Name"
                        name="patient_last_name"
                        id="patient_last_name"
                        type="text"
                        disable={buttonLoader}
                        maxLength={30}
                        value={formik.values.patient_last_name}
                        onChange={formik.handleChange}
                        onkeypress={alphabetValidate}
                        errors={formik.errors.patient_last_name 
                            && 
                            formik.touched.patient_last_name}
                        placeholder="Enter patient last name"
                        onBlur={formik.handleBlur}
                        required
                    />
                    {formik.errors.patient_last_name && formik.touched.patient_last_name ? (
                        <ErrorMessage>{formik.errors.patient_last_name}</ErrorMessage>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>

                

                <div className="w-full col-span-1 mb-[2px]">
                    <SelectInput
                        divStyle="mt-[2px]"
                        label={'Gender'}
                        minLength={6}
                        placeholder="Select Gender"
                        maxLength={50}
                        name="gender"
                        id="gender"
                        value={formik.values.gender}
                        errors={formik.errors.gender && formik.touched.gender}
                        onChange={formik.handleChange}
                        disable={buttonLoader}
                        onBlur={formik.handleBlur}
                        options={[{id:'male',label:'Male'},{id:'female',label:'Female'},{id:'unknown',label:'Unknown'}]}
                        valueKey = {'id'}
                        labelKey = {'label'}
                        required
                    />
                    {formik.errors.location && formik.touched.location ? (
                        <ErrorMessage>{formik.errors.location}</ErrorMessage>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>
                <div className="w-full col-span-1 mb-[2px]">
                    <SelectInput
                        divStyle="mt-[2px]"
                        label={'Location'}
                        minLength={6}
                        placeholder="Select Location"
                        maxLength={50}
                        name="location"
                        id="location"
                        value={formik.values.location}
                        errors={formik.errors.location && formik.touched.location}
                        onChange={formik.handleChange}
                        disable={buttonLoader}
                        onBlur={formik.handleBlur}
                        options={facilityList}
                        valueKey = {'facilityName'}
                        labelKey = {'facilityName'}
                        required
                    />
                    {formik.errors.location && formik.touched.location ? (
                        <ErrorMessage>{formik.errors.location}</ErrorMessage>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>
                <div className="w-full col-span-1 mb-[2px]">
                    <TextIconInput
                        divStyle="mt-[2px]"
                        label={"DOB"}
                        minLength={4}
                        placeholder="Patient date of brith"
                        maxLength={50}
                        name="DOB"
                        id="DOB"
                        value={formik.values.DOB}
                        errors={formik.errors.DOB && formik.touched.DOB}
                        onChange={formik.handleChange}
                        disable={buttonLoader}
                        onBlur={formik.handleBlur}
                        type={"date"}
                        required
                    />
                            
                    {formik.errors.DOB && formik.touched.DOB ? (
                        <ErrorMessage>{formik.errors.DOB}</ErrorMessage>
                    ) : (
                        <span>&nbsp;</span>
                    )}
                </div>

                {poupDetails.error && <div className="w-full col-span-1 mb-[4px]"> 
                    <div className="w-full relative mt-[2px]">
                        <label htmlFor="DOB" className="font-medium text-[12px] text-[#1C2A3D] leading-[100%]">
                            Error
                        </label>
                        <textarea
                            placeholder="Patient date of birth"
                            id="DOB"
                            name="DOB"
                            disabled={true}
                            minLength={4}
                            maxLength={50}
                            className="w-full text-[14px] py-[12px] border rounded-[8px] h-full px-[14px] placeholder:text-[#9AA0A9] font-medium border-[#E6E7E8] disabled:cursor-not-allowed disabled:text-[#252323] focus:outline-none focus:border-[#BEBEBE] leading-[16px] mt-[6px]"
                            style={{boxShadow: "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px"}}
                            value={poupDetails.error}
                        />
                        </div>

                </div>}

            </div>

        </SidePopup>
    );
};
